import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { useQueryParams } from '@hooks/queryParams';
import { ResourcesEquipmentRespSuccess } from './types';
import { getActive, useResourceType } from '../helpers';
import { usePanel } from '@hooks/usePanel';
import { useParams } from 'react-router';
import { DEFAULT_ITEMS_PER_PAGE } from '@components/pagination/constants';

export const useGetResourcesEquipment = () => {
  const {
    params: { page, items, search, status, sort: sortingValue, direction: sortingDirection },
    parseParams,
  } = useQueryParams();

  const { panel } = usePanel();
  const { tenantId } = useParams();
  const type = useResourceType();

  const queryParams = parseParams(
    {
      page: page || 1,
      items: items || DEFAULT_ITEMS_PER_PAGE,
      search,
      active: getActive(status || []),
      sortingValue: sortingValue || 'name',
      sortingDirection: sortingDirection || 'asc',
    },
    { arrayFormat: 'bracket' },
  );

  const { data, error, isPending } = useQuery<ResourcesEquipmentRespSuccess, ApiError>({
    queryKey: [...queryKeys.resources.equipment, queryParams],
    queryFn: () =>
      queryFetch({
        url: [panel ? `tenants/${tenantId}/` : '', `resources/assets${queryParams}`].join(''),
        panel,
      }),
    placeholderData: (previousData) => previousData as ResourcesEquipmentRespSuccess,
    enabled: type === 'equipment',
  });

  return {
    data,
    error,
    isLoading: isPending && type === 'equipment',
  };
};
